<template>
  <aside class="cebianlan">
    <div class="inner-warp">
      <div class="title">{{title}}
        <a href="#/index/aside-peop" @click="goback(false)">查看外出办证人员</a>
      </div>
      <div class="number-title">
        <div class="list" v-for="(item, index) in theTitle">
          <span>{{item.name}}</span>
          <i>{{item.number}}</i>
        </div>
      </div>
      <ul class="place-number-warp" v-iscroll>
        <div class="warp-box">
          <li class="list" v-for="(item, index) in zoneList" @click="hoverCityOut(false)">
            <a href="#/index/office">
              <span class="name">{{item.name}}</span>
              <span class="number">{{item.number}}</span>
            </a>
          </li>
        </div>
      </ul>
    </div>
  </aside>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import VIscroll from 'viscroll'
  export default {
    components: { VIscroll },
    data () {
      return {
        title: '上海公证处',
        titleNumber: [{name: '1', number: '2'}, {name: '1', number: '2'}]
      }
    },
    computed: {
      ...mapGetters({
        theTitle: 'numberTitle',
        zoneList: 'personnelList'
      })
    },
    watch: {
      theTitle () {
        this.titlNumber = this.theTitle
      },
      zoneList () {
        this.titleNumber = this.zoneList
      }
    },
    methods: {
      ...mapActions([
        'getListaa',
        'AgetPresListShow',
        'AgetBack'
      ]),
      hoverCityOver () {
        this.getListaa()
      },
      hoverCityOut (swit) {
        this.AgetBack(swit)
      },
      goback (swit) {
        this.AgetBack(swit)
      }
    },
    created () {
      setTimeout(() => {
        this.titlNumber = this.theTitle
        console.log(this.titlNumber)
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">

  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .cebianlan {
    position: absolute;
    left: 10px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 380px;
    height: 90%;
    overflow: hidden;
    border-radius: 6px;
    background: rgba($brand, .9);
    .inner-warp {
      position: relative;
      width: 100%;
      height: 100%;
      .title {
        width: 100%;
        height: 70px;
        text-align: left;
        line-height: 70px;
        padding-left: 17px;
        padding-right: 17px;
        font-size: 20px;
        color: $white;
        font-weight: bold;
        border-radius: 6px;
        background: $brand;
        a {
          float: right;
          color: $white;
          font-size: 15px;
        }
      }
    }
    .number-title {
      width: 100%;
      height: auto;
      padding-left: 17px;
      padding-right: 17px;
      padding-top: 10px;
      padding-bottom: 10px;
      .list {
        width: 100%;
        height: 45px;
        margin-bottom: 5px;
        padding-left: 35px;
        padding-right: 35px;
        line-height: 45px;
        color: $white;
        font-size: 20px;
        background: rgba($white, .3);
        border-radius: 6px;
        cursor: pointer;
        i {
          float: right;
          font-style: normal;
        }
      }
      .list:last-child {
        margin-bottom: 0;
      }
    }
    .place-number-warp {
      position: relative;
      width: 100%;
      height: calc(100% - 260px);
      margin: 0;
      padding-left: 17px;
      padding-right: 17px;
      list-style: none;
      overflow: hidden;
      .list {
        position: relative;
        width: 100%;
        margin-bottom: 5px;
        background: rgba($white, .1);
        border-radius: 6px;
        transition: transform .3s ease;
        a {
          height: 45px;
          display: block;
          position: relative;
          padding-left: 35px;
          padding-right: 35px;
          line-height: 45px;
          color: $white;
          font-size: 20px;
          box-sizing: border-box;
        }
      }
    .list:hover {
      // transform: scale(1.05);
      background: rgba($white, .5);
    }
      span {
        display: inline-block;
        max-width: 50%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .number {
        float: right;
      }
      .inner-list {
        position: relative;
        width: 100%;
        max-height: 0;
        margin: 0;
        padding: 0;
        list-style: none;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        overflow: hidden;
        background: rgba($white, .2);
        transition: max-height .3s;
        &.active {
          max-height:200px;
        }
      }
      .inner-list li {
        position: relative;
        width: 100%;
        font-size: 20px;
        height: auto;
        line-height: 100%;
        color: $white;
        cursor: pointer;
        &:hover {
          background: $brand;
        }
      }
    }
  }
  .warp-box {
    width: 100%;
    height: auto;
  }
</style>




// WEBPACK FOOTER //
// Aside.vue?81186036